export { default as ENTRY } from './entry';
export const PATH = '/videovisit';
export const BookingPath = '/videovisit/book';
export const pageName = 'Telehealth';

export const TELEHEALTH_GA_CATEGORY = 'Telehealth';
export const analytics = {
    pageCategory: () => 'Telehealth',
    rollUpBucket: () => 'Telehealth',
    pageType: () => 'Telehealth',
};
